import React from 'react'
import ProgressBar from 'react-toolbox/lib/progress_bar'
import CSSModules from 'react-css-modules'

import styles from './FulcrumProgressBar.scss'

const FulcrumProgressBar = (props) => {
  return (
    <ProgressBar theme={styles} {...props}/>
  )
}

export default CSSModules(FulcrumProgressBar, styles)
